/**
 * Makes sure that only one browser tab is viewing a record
 * at the same time
 */
// import { useEffect } from "react";
import { v4 as uuid } from "uuid";

import { getRecordIdAndType } from "../../helpers";
import styles from "./styles.module.scss";

let interval;

export default function VersionLock() {
  // only run this on record edit pages
  // don't run on local environments because it clogs the server logs
  if (
    document.querySelectorAll("body[class$='-edit']").length &&
    location.host.includes("contemporaryartlibrary.org")
  ) {
    checkServer();

    interval = setInterval(checkServer, 4000);
  }
}

let index = 0;

// find the unique identifier for this particular tab
function getBrowserTabId() {
  const idFromStorage = sessionStorage.getItem("browserTabId");
  if (idFromStorage) {
    return idFromStorage;
  }
  const id = uuid();
  sessionStorage.setItem("browserTabId", id);
  return id;
}

function checkServer() {
  const { recordId, recordType } = getRecordIdAndType();
  const tabId = getBrowserTabId();

  if (Number(recordId) && recordType) {
    $.ajax({
      url: "/version_lock",
      data: { id: recordId, type: recordType, index, tabId },
      type: "POST",
      success: (response) => {},
      error: (response) => {
        console.log("response error", response);
        if (response.status === 422) {
          const bodyEl = document.querySelector("body");
          bodyEl.classList.add(styles.readOnly);

          setTimeout(() => {
            alert(
              "You are viewing this page in read-only mode because it is being accessed in another browser or tab.\n\nIf you want to make changes, please close the other tab or wait for another user to finish editing this record and then refresh the page."
            );
          }, 50);
        }

        // If there are other errors, silently fail in order to not bother user

        if (interval) clearInterval(interval);
      },
    });
  }

  index++;
}
